// extracted by mini-css-extract-plugin
export default {"special":"Price__special___onTSL","promocode":"Price__promocode___pgqRA","title":"Price__title___ZdGul","value":"Price__value___sPeXc","currency":"Price__currency___ZTIIF"};